import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
    	errorTypeEnum: {
    		labelShouldBeUniq: 'Ce nom existe déjà',
            lastCategoryCanNotBeRemoved: 'Une raison d\'ouverture de ticket doit avoir au moins une catégorie',
            categoryIsAlreadyAssociatedWithOpeningTicketPurpose: 'Cette catégorie est déjà associée à la raison d\'ouverture de ticket',
            lastTagCanNotBeRemoved: 'Une raison d\'ouverture de ticket doit avoir au moins un tag',
            openingTicketPurposeDoesNotExist: 'Cette raison d\'ouverture de ticket n\'est pas éditable'
    	},
        openingTicketPurposes: 'raisons d\'ouverture de ticket',
    	newOpeningTicketPurpose: 'nouvelle raison d\'ouverture de ticket',
        searchOpeningTicketPurpose: 'rechercher une demande',
    	categories: 'catégories',
        manageCategories: 'catégories',
    	searchCategory: 'rechercher une catégorie',
        newCategory: 'nouvelle catégorie',
        updateCategory: 'modification',
    	addCategory: 'ajouter une catégorie',
        addChildCategory: 'ajouter une sous catégorie',
        parentCategory: 'parent',
    	tags: 'tags',
        manageTags: 'tags',
    	searchTag: 'rechercher un tag',
        newTag: 'nouveau tag',
        updateTag: 'modification',
        addTag: 'ajouter un tag',
        icon: 'icon',
        searchIcon: 'rechercher une icon',
        activities: 'activités',
        associateActivity: 'associer une activité',
        associateActivityText: [
            'associez cette raison d\'ouverture de ticket aux contacts fournisseurs de votre choix'
        ],
        dissociateActivity: 'dissocier une activité',
        dissociateActivityText: [
            'Vous êtes sur le point de dissocier l\'activité {label}.',
            '[[{count} contacts fournisseurs ne seront plus associés à cette raison d\'ouverture de ticket.]]'
        ],
        reference: 'référence externe',
        referenceInfo: 'la référence externe vous sert à faire le lien entre votre référentiel sur l\'application et un éventuel référentiel sur un autre système',
        enableOpeningTicketPurpose: 'activer la raison d\'ouverture de ticket ...',
        enableOpeningTicketPurposeText: [
            'Vous êtes sur le point d\'activer la raison d\'ouverture de ticket {label}.'
        ],
        disableOpeningTicketPurpose: 'désactiver la raison d\'ouverture de ticket ...',
        disableOpeningTicketPurposeText: [
            'Vous êtes sur le point de désactiver la raison d\'ouverture de ticket {label}.'
        ],
        searchProviderContact: 'rechercher un contact fournisseur',
        providerContactDissociatedFromOpeningTicketPurpose: '{count} contacts fournisseurs ont été dissociés de cette raison d\'ouverture de ticket'
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/reference/i18n.js